import {
  ClockIcon,
  UserGroupIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";

// Helpers d'affichage local (pas d'ISO → on reconstruit une Date locale)
const prettyDate = (ymd) => {
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString("fr-CA", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
};

const ServiceSlots = ({
  selectedDate,
  slots,
  selectedSlot,
  onSelectSlot,
  t,
}) => {
  return (
    <div className="bg-white border-2 border-[#FFD76A]/30 rounded-xl overflow-hidden">
      <div className="bg-gradient-to-r from-[#FFD76A]/50 to-[#FFD76A]/60 px-5 py-3 border-b border-[#FFD76A]/30">
        <p className="font-semibold text-gray-900 flex items-center gap-2">
          <ClockIcon className="w-4 h-4 text-primary" />
          {t
            ? t("global.slots_for", "Créneaux pour le")
            : "Créneaux pour le"}{" "}
          {prettyDate(selectedDate)}
        </p>
      </div>

      <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {slots.map((slot, idx) => {
          const isSelected =
            selectedSlot?.date === slot.date &&
            selectedSlot?.startTime === slot.startTime;

          const isLowCapacity = (slot?.remainingCapacity ?? 0) <= 2;

          return (
            <button
              key={idx}
              type="button"
              onClick={() => onSelectSlot(isSelected ? null : slot)}
              className={`relative p-4 rounded-xl border-2 text-left transition-all duration-200 ${
                isSelected
                  ? "bg-primary border-primary text-white shadow-lg scale-105"
                  : "bg-white border-gray-200 hover:border-[#FFD76A] hover:shadow-md"
              }`}
            >
              {isSelected && (
                <CheckCircleIcon className="absolute top-2 right-2 w-5 h-5" />
              )}

              <div className="flex items-center gap-2 mb-2">
                <ClockIcon
                  className={`w-4 h-4 ${
                    isSelected ? "text-white" : "text-gray-400"
                  }`}
                />
                <span className="font-semibold">
                  {slot.startTime} - {slot.endTime}
                </span>
              </div>

              <div
                className={`flex items-start gap-1.5 text-sm mb-1 ${
                  isSelected ? "text-white/90" : "text-gray-600"
                } `}
                style={{ minHeight: "32px" }} // empêche les sauts visuels
              >
                {/* Icon */}
                <UserGroupIcon className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />

                {/* Text */}
                <div
                  className={`flex items-center gap-1.5 text-sm mb-1 ${
                    isSelected && !isLowCapacity
                      ? "text-white/90"
                      : "text-gray-600"
                  } ${isLowCapacity ? "text-orange-600" : ""}`}
                >
                  <span>
                    {slot?.remainingCapacity ?? 0}{" "}
                    {(slot?.remainingCapacity ?? 0) === 1
                      ? "disponibilité"
                      : "disponibilités"}
                  </span>
                </div>
              </div>

              {slot.price > 0 && (
                <div
                  className={`text-sm font-bold mt-2 ${
                    isSelected ? "text-white" : "text-primary"
                  }`}
                >
                  {Number(slot.price).toFixed(2)} $
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ServiceSlots;
